// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import VueMaterial from 'vue-material';
import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/en';
import infiniteScroll from 'vue-infinite-scroll';
import { VueMasonryPlugin } from 'vue-masonry';
import VueI18n from 'vue-i18n';
import Fragment from 'vue-fragment';
import 'babel-polyfill';
import moment from 'moment';

import 'vue-material/dist/vue-material.min.css';
import 'vue-material/dist/theme/default.css';
import './css/element/index.css';
import 'vue-slider-component/theme/default.css';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/fonts/slick.ttf';

import '~lib/common/css/dialog-globals.css';
import '~lib/common/css/globals.css';
import '~lib/common/css/new-globals.css';
import store from '~lib/common/store';
import closeOnZoom from '~lib/case-logic-builder/directives/closeOnZoom';
import analytics from '~lib/common/providers/analytics';
import featureAvailabilityService from '~lib/common/providers/featureAvailabilityService';

import App from './App.vue';
import router from './router';

import integerOnly from './directives/integerOnly';
import testid from './directives/testid';

Vue.config.performance = false;
Vue.use(VueMaterial);
Vue.use(ElementUI, { locale });
Vue.use(infiniteScroll);
Vue.use(VueMasonryPlugin);
Vue.use(VueI18n);
Vue.use(analytics, {
  router
});
Vue.use(featureAvailabilityService);
Vue.use(Fragment.Plugin);

// Global date filters
Vue.filter('formatDate', timestamp => moment(timestamp).format('M/DD/YYYY'));
Vue.filter('formatTime', timestamp => moment(timestamp).format('h:mm A'));

// Default max length on all inputs and textareas
const MdTextArea = Vue.options.components.MdTextarea;
const MdInput = Vue.options.components.MdInput;
const MdField = Vue.options.components.MdField;
const ElInput = Vue.options.components.ElInput;
Vue.component('mdTextarea', MdTextArea.extend({
  props: {
    maxlength: {
      type: Number,
      default: 10000,
    },
  },
}));
Vue.component('mdInput', MdInput.extend({
  props: {
    maxlength: {
      type: Number,
      default: 512,
    },
  },
}));
Vue.component('elInput', ElInput.extend({
  props: {
    maxlength: {
      type: Number,
      default: 512,
    },
  },
}));
Vue.component('mdField', MdField.extend({
  props: {
    mdCounter: {
      type: Boolean,
      default: false,
    },
  },
}));

Vue.directive('integerOnly', integerOnly);
// Event hub pattern in VueJS
// https://medium.com/vuejobs/create-a-global-event-bus-in-vue-js-838a5d9ab03a
Vue.prototype.$eventHub = new Vue();

// Register a global custom directive called `v-focus`
Vue.directive('closeOnZoom', closeOnZoom)

// Register a global custom directive called `v-testid`
Vue.directive('testid', testid);

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>',
  i18n: new VueI18n({
    locale: window.__VES_RETAIL_NAMESPACE__.i18n.locale,
    messages: window.__VES_RETAIL_NAMESPACE__.i18n.messages,
    silentTranslationWarn: true,
  }),
});
